export enum VirtualAccountType {
  ALL_ACCTS = 'ALL_ACCTS',
}

export enum ContentfulApplicationPageCustomerClass {
  COM = 'Commercial Only',
  RES = 'Residential Only',
}
